module.exports = __webpack_public_path__ + "media/images/light-button-right-002ae384078f15fdc33fe1311ab63e15.png";